export { Occupancy } from './Occupancy'
export type { OccupancyProps, OccupancyTranslations } from './Occupancy'
